/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import { FormTextField } from 'components/TextField';
import { Form, FieldProps, Field, FormikProps } from 'formik';
import Button from 'components/Button';
import useTranslate from 'hooks/useTranslate';

import { FormValues } from './EmailDisclosureButton';

type PropTypes = FormikProps<FormValues> & {
  onClose?: () => void;
};

const EmailDisclosureModalView: React.FC<PropTypes> = props => {
  const { isValid, isSubmitting, onClose } = props;
  const t = useTranslate();
  return (
    <Dialog
      disableBackdropClick={isSubmitting}
      disableEscapeKeyDown={isSubmitting}
      fullWidth
      maxWidth="xs"
      aria-labelledby="email-disclosures-title"
      open={true}
      onClose={onClose}
    >
      <Form>
        <DialogContent>
          <DialogContentText id="email-disclosures-title">
            Please enter your email address
          </DialogContentText>
          <Field name="emailAddress">
            {(fieldProps: FieldProps) => {
              return (
                <FormTextField
                  id="emailDisclosure"
                  fieldProps={fieldProps}
                  inputProps={{ maxLength: 50 }}
                  label={t('formLabel.emailAddress')}
                  margin="dense"
                />
              );
            }}
          </Field>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="text"
            type="submit"
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
          >
            {'Send disclosures'}
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default EmailDisclosureModalView;
